import { useRef } from 'react'

import { useHistory } from 'react-router-dom'

import { Types } from '@tribeplatform/gql-client/'
import { Form } from '@tribeplatform/react-sdk/components'
import {
  SystemSpaceSlug,
  useCreateCollection,
  useSpaceUtil,
  useUpdateCollection,
} from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

export const CollectionFormModal = ({
  collection,
  open,
  onClose,
}: {
  collection?: Types.Collection
  open: boolean
  onClose: () => void
}) => {
  const inputRef = useRef<HTMLInputElement>()
  const { mutateAsync: createCollection, isLoading: isCreating } =
    useCreateCollection({
      fields: 'basic',
    })
  const { mutateAsync: updateCollection, isLoading: isUpdating } =
    useUpdateCollection()
  const history = useHistory()
  const { generatePath } = useSpaceUtil()
  const isNew = !collection?.id

  return (
    <Modal open={open} onClose={onClose} initialFocus={inputRef}>
      <Modal.Header
        title={isNew ? 'Create a new collection' : 'Edit collection'}
      />
      <Modal.Content>
        <Form
          defaultValues={collection}
          onSubmit={async data => {
            const { name, description } = data
            const input = {
              name,
              description,
            }

            if (collection?.id)
              return updateCollection({
                id: collection.id,
                input,
              }).then(() => {
                onClose()
              })

            return createCollection({
              input,
            }).then(collection => {
              onClose()
              history.push(
                generatePath(SystemSpaceSlug.COLLECTION, { id: collection.id }),
              )
            })
          }}
        >
          <div className="flex flex-col space-y-5">
            <Form.Input
              ref={inputRef}
              label="Name"
              name="name"
              placeholder="Choose a helpful name (e.g. Resources)"
              validation={{ required: 'Please enter a name' }}
            />
            <Form.Textarea
              label="Description"
              name="description"
              placeholder="What is this collection about? (e.g. All the resources you need to get started)"
            />
            <Form.Actions>
              <Button
                variant="primary"
                type="submit"
                loading={isCreating || isUpdating}
              >
                {isNew ? 'Create' : 'Update'}
              </Button>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
            </Form.Actions>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  )
}
